module.exports = __webpack_public_path__ + "assets-cabinet/img/enter.a2e1cec9.svg";